module.exports = __webpack_public_path__ + "static/media/image1.945d2e2b.jpg";